import { useCallback, useState } from "react";
import { HudDetailsCard } from "@/components/profile-cards";
import type { IInspectorHud } from "@/types/users-inspectors";
import { useBoolean } from "@/ui-kit";
import EditModal from "./EditModal";

type IProps = {
  userId: number;
  hudDetails: IInspectorHud;
};

export const HudDetails = ({ userId, hudDetails }: IProps) => {
  const [values, setValues] = useState<IInspectorHud>(hudDetails);

  const updateValues = useCallback((v: IInspectorHud) => {
    setValues(v);
  }, []);

  const {
    value: showEditUserModal,
    setTrue: openEditUserModal,
    setFalse: dismissEditUserModal,
  } = useBoolean(false);

  return (
    <>
      <HudDetailsCard hudDetails={values} onEdit={openEditUserModal} />
      {showEditUserModal && (
        <EditModal
          userId={userId}
          hudDetail={values}
          onSave={updateValues}
          onDismiss={dismissEditUserModal}
        />
      )}
    </>
  );
};
